// /map/logic/utils/npcVictoryRewards.js
import axios from '@/axios'
import { useDialogStore } from '@/map/stores/dialogStore'

/**
 * NPC胜利特殊奖励配置
 * key: npcId，内容自定义
 */
export const npcVictoryRewards = {
  'maptrainer_luvia_gym1': {
    itemId: 57, // 草系徽章id
    quantity: 1,
    dialogs: [
      { name: 'luvia', emotion: 'shy', text: '没想到你真的赢了……看来昨晚那种气势，不只是床上才有啊~' },
      { name: 'luvia', emotion: 'normal', text: '这是你的草系徽章，别弄丢了，下次再来“挑战”我也行~' }
    ],
    systemMsg: '获得草系徽章！'
  },
  'maptrainer_lunafrost_gym1': {
    itemId: 59, // 水系徽章id（请根据你的实际id填写）
    quantity: 1,
    dialogs: [
      { name: 'lunafrost', emotion: 'shy', text: '你居然真的把我打败了……昨晚在床上的勇气，今天在场上也用出来了吗？' },
      { name: 'lunafrost', emotion: 'normal', text: '……这是你的水系徽章，别弄丢了，下次想要更多奖励，记得先赢我哦。' }
    ],
    systemMsg: '获得水系徽章！'
  },
  'maptrainer_puni_xuwu': {
  itemId: 1001, // 虚无封印的碎片ID（你需要自行定义）
  quantity: 1,
  dialogs: [
    { name: 'puni', emotion: 'normal', text: '你……战胜了我。' },
    { name: 'puni', emotion: 'normal', text: '这是……我留下的印记。你拥有它，就拥有了改变命运的可能。' },
    { name: 'puni', emotion: 'normal', text: '去吧，挑战者。宇宙将因你而动摇。' }
  ],
  systemMsg: '获得道具：虚无封印的碎片！'
},
'maptrainer_glaciera_freya': {
  itemId: 66, // 冰系徽章id（按你的道具表实际id填写）
  quantity: 1,
  dialogs: [
    { name: 'freya', emotion: 'shy', text: '你还真行啊，把我都打服了。' },
    { name: 'freya', emotion: 'shy', text: '这是冰系徽章。昨晚你的表现不错，今天也不差～' }
  ],
  systemMsg: '获得冰系徽章！'
},
'maptrainer_puni_zhenshen': {
  itemId: 2005, // 谱尼的精元ID（你自定义一个唯一的ID，比如2008）
  quantity: 1,
  dialogs: [
    { name: 'puni', emotion: 'normal', text: '……你竟然打破了我的全部封印。' },
    { name: 'puni', emotion: 'normal', text: '这，是我最后的力量，也是谱尼唯一的精元。' },
    { name: 'puni', emotion: 'normal', text: '好好珍惜它吧，这将开启真正的奇迹。' }
  ],
  systemMsg: '获得道具：谱尼的精元！'
},
'maptrainer_roselia_gym': {
  itemId: 61, // 电系徽章id（按你的道具表实际id填写）
  quantity: 1,
  dialogs: [
    { name: 'roselia', emotion: 'shy', text: '居然真被你打败了……' },
    { name: 'roselia', emotion: 'shy', text: '这是电系徽章，昨晚你也挺厉害，今天也不差～' }
  ],
  systemMsg: '获得电系徽章！'
},
'maptrainer_elementaldrow_psygym1': {
  itemId: 63, // 超能系徽章id（请根据你的实际id填写）
  quantity: 1,
  dialogs: [
    { name: 'elementaldrow', emotion: 'normal', text: '你的心象没有被击碎……看来你已经通过了考验。' },
    { name: 'elementaldrow', emotion: 'normal', text: '这是象征超能的徽章。收好它，不要让你的心灵被外界左右。' }
  ],
  systemMsg: '获得超能系徽章！'
},

'maptrainer_elementalespeon': {
  itemId: 64, // 战神道馆徽章id（请根据你的实际id填写）
  quantity: 1,
  dialogs: [
    { name: 'elementalespeon', emotion: 'normal', text: '……连我也被你击败了，看来你的意志与力量都已被淬炼成钢。' },
    { name: 'elementalespeon', emotion: 'normal', text: '这是战神徽章，它代表的不只是胜利，更是永不退缩的决心。' }
  ],
  systemMsg: '获得战神徽章！'
},
'maptrainer_empress': {
  itemId: 67, // 胜利徽章id
  quantity: 1,
  dialogs: [
    { name: 'empress', emotion: 'normal', text: '……你已跨过门槛，连胜利也向你低头。' },
    { name: 'empress', emotion: 'normal', text: '这是胜利徽章。带着它，去面对更强的风暴。' }
  ],
  systemMsg: '获得胜利徽章！'
},
'maptrainer_boss_arksia': {
  itemId: 2006, 
  quantity: 1,
  dialogs: [
    { name: 'boss_arksia', emotion: 'normal', text: '恭喜你战胜了最强的冰系精灵阿克西亚。' },
    { name: 'boss_arksia', emotion: 'normal', text: '你获得了阿克西亚的精元。。' }
  ],
  systemMsg: '获得道具：阿克西亚的精元'
},
'maptrainer_boss_younasi': {
  itemId: 2007,
  quantity: 1,
  dialogs: [
    { name: 'boss_younasi', emotion: 'normal', text: '……不错，凡人。你竟能击败幽冥之主尤纳斯。' },
    { name: 'boss_younasi', emotion: 'normal', text: '这份精元，象征着你对幽暗之力的掌控。' },
    { name: 'boss_younasi', emotion: 'normal', text: '好好利用它吧，别让黑暗反噬你的灵魂。' }
  ],
  systemMsg: '获得道具：尤纳斯的精元'
},
'maptrainer_boss_xuanwu': {
  itemId: 2008,
  quantity: 1,
  dialogs: [
    { name: 'boss_xuanwu', emotion: 'normal', text: '汝之坚毅，令大地亦为之震颤……' },
    { name: 'boss_xuanwu', emotion: 'normal', text: '吾乃玄武，水与岩之守护者。凡能承受吾之试炼者，理应得此精元。' },
    { name: 'boss_xuanwu', emotion: 'normal', text: '持此之力，当以守护为念，而非征伐。' }
  ],
  systemMsg: '获得道具：玄武的精元'
},

'maptrainer_boss_2366': {
  itemId: 2009,
  quantity: 1,
  dialogs: [
    { name: 'boss_palsas', emotion: 'normal', text: '你击败了深渊领主帕尔萨斯……你的力量已被承认。' },
    { name: 'boss_palsas', emotion: 'normal', text: '你获得了帕尔萨斯的精元。' }
  ],
  systemMsg: '获得道具：帕尔萨斯的精元'
},

'maptrainer_boss_3525': {
  itemId: 2010,
  quantity: 1,
  dialogs: [
    { name: 'boss_phoenix', emotion: 'normal', text: '连魔晶凤凰也无法阻挡你的前进……你的实力令人震撼。' },
    { name: 'boss_phoenix', emotion: 'normal', text: '你获得了魔晶凤凰的精元。' }
  ],
  systemMsg: '获得道具：魔晶凤凰的精元'
},

'maptrainer_boss_3731': {
  itemId: 2011,
  quantity: 1,
  dialogs: [
    { name: 'boss_shura', emotion: 'normal', text: '修罗之力被你压制……你值得从深渊中带走它的印记。' },
    { name: 'boss_shura', emotion: 'normal', text: '你获得了镇狱修罗王的精元。' }
  ],
  systemMsg: '获得道具：镇狱修罗王的精元'
},

'maptrainer_boss_5263': {
  itemId: 2012,
  quantity: 1,
  dialogs: [
    { name: 'boss_cynthia', emotion: 'normal', text: '你连弥迹辛西娅都能战胜……你的命运已被自然认可。' },
    { name: 'boss_cynthia', emotion: 'normal', text: '你获得了弥迹辛西娅的精元。' }
  ],
  systemMsg: '获得道具：弥迹辛西娅的精元'
},

'maptrainer_boss_10261': {
  itemId: 2013,
  quantity: 1,
  dialogs: [
    { name: 'boss_gaia', emotion: 'normal', text: '盖亚的怒意被你平息……你的战意足以震动大地。' },
    { name: 'boss_gaia', emotion: 'normal', text: '你获得了盖亚的精元。' }
  ],
  systemMsg: '获得道具：盖亚的精元'
},

'maptrainer_boss_10503': {
  itemId: 2014,
  quantity: 1,
  dialogs: [
    { name: 'boss_taiger', emotion: 'normal', text: '泰戈尔的雷霆止息……你已获得白虎神威的认可。' },
    { name: 'boss_taiger', emotion: 'normal', text: '你获得了泰戈尔的精元。' }
  ],
  systemMsg: '获得道具：泰戈尔的精元'
},
'maptrainer_bingfeng_knight_1': {
  itemId: 94, // 洛克冰徽章 id
  quantity: 1,
  dialogs: [
    { name: 'bingfeng_knight', emotion: 'normal', text: '……这场切磋，是你赢了。你在风雪里站得比我想象中更稳。' },
    { name: 'bingfeng_knight', emotion: 'normal', text: '这是象征洛克冰域的徽章。收好它，它代表的不是寒冷，而是你在寒冷中也没有退后。' }
  ],
  systemMsg: '获得「洛克冰徽章」！'
},
'maptrainer_boss_dragonking': {
  itemId: 2019,
  quantity: 1,
  dialogs: [
    { name: 'boss_dragonking', emotion: 'normal', text: '不错，你战胜了号令万龙的【龙族之王】。' },
    { name: 'boss_dragonking', emotion: 'normal', text: '作为证明，你获得了龙族之王的精元。' }
  ],
  systemMsg: '获得道具：龙族之王的精元'
},

'maptrainer_boss_shigandang': {
  itemId: 2015,
  quantity: 1,
  dialogs: [
    { name: 'boss_shigandang', emotion: 'normal', text: '连镇煞守护者【石敢当】都被你击退了。' },
    { name: 'boss_shigandang', emotion: 'normal', text: '这块精元，将见证你战胜万邪的力量。' }
  ],
  systemMsg: '获得道具：石敢当的精元'
},
'maptrainer_boss_yingkalos': {
  itemId: 2021,
  quantity: 1,
  dialogs: [
    { name: 'yingkalos', emotion: 'normal', text: '英卡洛斯收起了战意，微微点头，认可了你的实力。' },
    { name: 'yingkalos', emotion: 'normal', text: '你获得了英卡洛斯的精元。' }
  ],
  systemMsg: '获得道具：英卡洛斯的精元'
},










'maptrainer_boss_10042': {
  itemId: 2022,
  quantity: 1,
  dialogs: [
    { name: 'boss_liaosi', emotion: 'normal', text: '烈焰逐渐平息……里奥斯认可了你的战斗方式。' },
    { name: 'boss_liaosi', emotion: 'normal', text: '你获得了里奥斯的精元。' }
  ],
  systemMsg: '获得道具：里奥斯的精元'
},

'maptrainer_boss_10069': {
  itemId: 2023,
  quantity: 1,
  dialogs: [
    { name: 'boss_tiyasi', emotion: 'normal', text: '疾风停歇……提亚斯向你低下了高傲的羽翼。' },
    { name: 'boss_tiyasi', emotion: 'normal', text: '你获得了提亚斯的精元。' }
  ],
  systemMsg: '获得道具：提亚斯的精元'
},

'maptrainer_boss_10070': {
  itemId: 2024,
  quantity: 1,
  dialogs: [
    { name: 'boss_leiyi', emotion: 'normal', text: '雷鸣散去……雷伊承认了你的力量。' },
    { name: 'boss_leiyi', emotion: 'normal', text: '你获得了雷伊的精元。' }
  ],
  systemMsg: '获得道具：雷伊的精元'
},

'maptrainer_boss_10088': {
  itemId: 2025,
  quantity: 1,
  dialogs: [
    { name: 'boss_naduolei', emotion: 'normal', text: '大地恢复寂静……纳多雷认可了你的存在。' },
    { name: 'boss_naduolei', emotion: 'normal', text: '你获得了纳多雷的精元。' }
  ],
  systemMsg: '获得道具：纳多雷的精元'
},

'maptrainer_boss_10113': {
  itemId: 2026,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '钢铁意志被撼动……雷纳多向你致意。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了雷纳多的精元。' }
  ],
  systemMsg: '获得道具：雷纳多的精元'
},

'maptrainer_boss_10132': {
  itemId: 2027,
  quantity: 1,
  dialogs: [
    { name: 'boss_younasi', emotion: 'normal', text: '诅咒消散于阴影之中……尤纳斯不再敌视你。' },
    { name: 'boss_younasi', emotion: 'normal', text: '你获得了尤纳斯的精元。' }
  ],
  systemMsg: '获得道具：尤纳斯的精元'
},

'maptrainer_boss_10216': {
  itemId: 2028,
  quantity: 1,
  dialogs: [
    { name: 'boss_hamolete', emotion: 'normal', text: '龙威收敛……哈莫雷特认可了你的勇气。' },
    { name: 'boss_hamolete', emotion: 'normal', text: '你获得了哈莫雷特的精元。' }
  ],
  systemMsg: '获得道具：哈莫雷特的精元'
},

'maptrainer_boss_10264': {
  itemId: 2029,
  quantity: 1,
  dialogs: [
    { name: 'boss_nainifenduo', emotion: 'normal', text: '精神领域崩解……奈尼芬多向你敞开了心智。' },
    { name: 'boss_nainifenduo', emotion: 'normal', text: '你获得了奈尼芬多的精元。' }
  ],
  systemMsg: '获得道具：奈尼芬多的精元'
},

'maptrainer_boss_10274': {
  itemId: 2030,
  quantity: 1,
  dialogs: [
    { name: 'boss_takelin', emotion: 'normal', text: '冷冽的目光移开……塔克林认可了你的理性。' },
    { name: 'boss_takelin', emotion: 'normal', text: '你获得了塔克林的精元。' }
  ],
  systemMsg: '获得道具：塔克林的精元'
},

'maptrainer_boss_10384': {
  itemId: 2031,
  quantity: 1,
  dialogs: [
    { name: 'boss_boge', emotion: 'normal', text: '冲动被压制……波戈服从于你的力量。' },
    { name: 'boss_boge', emotion: 'normal', text: '你获得了波戈的精元。' }
  ],
  systemMsg: '获得道具：波戈的精元'
},

'maptrainer_boss_10391': {
  itemId: 2032,
  quantity: 1,
  dialogs: [
    { name: 'boss_taxiya', emotion: 'normal', text: '龙血平息……塔西亚接受了你的统御。' },
    { name: 'boss_taxiya', emotion: 'normal', text: '你获得了塔西亚的精元。' }
  ],
  systemMsg: '获得道具：塔西亚的精元'
},

'maptrainer_boss_10413': {
  itemId: 2033,
  quantity: 1,
  dialogs: [
    { name: 'boss_saiweier', emotion: 'normal', text: '压迫消散……塞维尔认可了你的绝对力量。' },
    { name: 'boss_saiweier', emotion: 'normal', text: '你获得了塞维尔的精元。' }
  ],
  systemMsg: '获得道具：塞维尔的精元'
},

'maptrainer_boss_10421': {
  itemId: 2034,
  quantity: 1,
  dialogs: [
    { name: 'boss_ersaila', emotion: 'normal', text: '命运丝线松动……厄尔塞拉向你微笑。' },
    { name: 'boss_ersaila', emotion: 'normal', text: '你获得了厄尔塞拉的精元。' }
  ],
  systemMsg: '获得道具：厄尔塞拉的精元'
},

'maptrainer_boss_10490': {
  itemId: 2035,
  quantity: 1,
  dialogs: [
    { name: 'boss_laokemengde', emotion: 'normal', text: '战魂不灭……劳克蒙德认可了你的不屈。' },
    { name: 'boss_laokemengde', emotion: 'normal', text: '你获得了劳克蒙德的精元。' }
  ],
  systemMsg: '获得道具：劳克蒙德的精元'
},

'maptrainer_boss_10501': {
  itemId: 2036,
  quantity: 1,
  dialogs: [
    { name: 'boss_baste', emotion: 'normal', text: '玄甲崩裂……巴斯特向你低下了头颅。' },
    { name: 'boss_baste', emotion: 'normal', text: '你获得了巴斯特的精元。' }
  ],
  systemMsg: '获得道具：巴斯特的精元'
},

'maptrainer_boss_10502': {
  itemId: 2037,
  quantity: 1,
  dialogs: [
    { name: 'boss_dorag', emotion: 'normal', text: '深海翻涌止息……朵拉格承认了你的支配。' },
    { name: 'boss_dorag', emotion: 'normal', text: '你获得了朵拉格的精元。' }
  ],
  systemMsg: '获得道具：朵拉格的精元'
},

'maptrainer_boss_10504': {
  itemId: 2038,
  quantity: 1,
  dialogs: [
    { name: 'boss_phoenix', emotion: 'normal', text: '不死之火重燃……菲尼克斯接受了你的意志。' },
    { name: 'boss_phoenix', emotion: 'normal', text: '你获得了菲尼克斯的精元。' }
  ],
  systemMsg: '获得道具：菲尼克斯的精元'
},

'maptrainer_boss_10505': {
  itemId: 2039,
  quantity: 1,
  dialogs: [
    { name: 'boss_ares', emotion: 'normal', text: '战争意志归于沉寂……阿瑞斯认可了你的统治。' },
    { name: 'boss_ares', emotion: 'normal', text: '你获得了阿瑞斯的精元。' }
  ],
  systemMsg: '获得道具：阿瑞斯的精元'
},
'maptrainer_boss_10222': {
  itemId: 2046,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '钢铁意志被撼动……卡库多向你致意。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了卡库的精元。' }
  ],
  systemMsg: '获得道具：卡库的精元'
},

'maptrainer_boss_5092': {
  itemId: 2079,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '潮汐回落……海芙向你低声致意。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了海芙的精元。' }
  ],
  systemMsg: '获得道具：海芙的精元'
},

'maptrainer_boss_5113': {
  itemId: 2080,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '圣辉收敛……天女兽向你点头。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了天女兽的精元。' }
  ],
  systemMsg: '获得道具：天女兽的精元'
},

'maptrainer_boss_5118': {
  itemId: 2081,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '星辉黯淡……灵渺星姬注视着你。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了灵渺星姬的精元。' }
  ],
  systemMsg: '获得道具：灵渺星姬的精元'
},

'maptrainer_boss_5130': {
  itemId: 2082,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '烈焰散去……路红收起战意。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了路红的精元。' }
  ],
  systemMsg: '获得道具：路红的精元'
},

'maptrainer_boss_5144': {
  itemId: 2083,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '雷鸣止息……霆霓缓缓退后。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了霆霓的精元。' }
  ],
  systemMsg: '获得道具：霆霓的精元'
},

'maptrainer_boss_5147': {
  itemId: 2084,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '铠影沉寂……灵铠骑士向你行礼。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了灵铠骑士的精元。' }
  ],
  systemMsg: '获得道具：灵铠骑士的精元'
},

'maptrainer_boss_5164': {
  itemId: 2085,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '光芒折返……阿尔贝西收回目光。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了阿尔贝西的精元。' }
  ],
  systemMsg: '获得道具：阿尔贝西的精元'
},

'maptrainer_boss_5172': {
  itemId: 2086,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '龙威暂歇……巴哈姆特发出低吼。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了巴哈姆特的精元。' }
  ],
  systemMsg: '获得道具：巴哈姆特的精元'
},

'maptrainer_boss_5181': {
  itemId: 2087,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '骨翼收拢……遮天骨龙的杀意消散。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了遮天骨龙的精元。' }
  ],
  systemMsg: '获得道具：遮天骨龙的精元'
},

'maptrainer_boss_5218': {
  itemId: 2088,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '绯焰冷却……绯衣轻轻转身。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了绯衣的精元。' }
  ],
  systemMsg: '获得道具：绯衣的精元'
},

'maptrainer_boss_5249': {
  itemId: 2089,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '战鼓止响……轰鼓元帅认可了你。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了轰鼓元帅的精元。' }
  ],
  systemMsg: '获得道具：轰鼓元帅的精元'
},

'maptrainer_boss_5276': {
  itemId: 2090,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '藤影松开……钩藤撤去束缚。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了钩藤的精元。' }
  ],
  systemMsg: '获得道具：钩藤的精元'
},

'maptrainer_boss_5277': {
  itemId: 2091,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '沙岚散尽……蚩岚沉默片刻。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了蚩岚的精元。' }
  ],
  systemMsg: '获得道具：蚩岚的精元'
},

'maptrainer_boss_5280': {
  itemId: 2092,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '梦幕落下……夏洛蒂向你微笑。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了夏洛蒂的精元。' }
  ],
  systemMsg: '获得道具：夏洛蒂的精元'
},

'maptrainer_boss_5318': {
  itemId: 2093,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '时隙闭合……洛时鹉缓缓停下。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了洛时鹉的精元。' }
  ],
  systemMsg: '获得道具：洛时鹉的精元'
},

'maptrainer_boss_10804': {
  itemId: 2094,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '压迫感如山崩般袭来……迪符特缓缓收势。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了迪符特的精元。' }
  ],
  systemMsg: '获得道具：迪符特的精元'
},
'maptrainer_boss_10811': {
  itemId: 2095,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '远古的绿意轰鸣回响……始祖灵兽踏碎尘埃。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了始祖灵兽的精元。' }
  ],
  systemMsg: '获得道具：始祖灵兽的精元'
},
'maptrainer_boss_12000': {
  itemId: 2096,
  quantity: 1,
  dialogs: [
    { name: 'boss_leinaduo', emotion: 'normal', text: '群星坠落般的威压散去……索伦森收回目光。' },
    { name: 'boss_leinaduo', emotion: 'normal', text: '你获得了索伦森的精元。' }
  ],
  systemMsg: '获得道具：索伦森的精元'
},

'maptrainer_boss_10695': {
  itemId: 2101,
  quantity: 1,
  dialogs: [
    { name: '狄修斯', emotion: 'normal', text: '群星坠落般的威压散去……狄修斯收回目光。' },
    { name: '狄修斯', emotion: 'normal', text: '你获得了狄修斯的精元。' }
  ],
  systemMsg: '获得道具：狄修斯的精元'
},





  // 以后其它馆主直接在这里加
  // 'maptrainer_xxx_gym2': { ... }
}

/**
 * 检查是否有特殊奖励并处理（有则处理，无则啥也不做）
 * @param {string} npcId
 * @param {string} playerId
 * @returns {Promise<boolean>} 是否已处理
 */
export async function tryGrantNpcVictoryReward(npcId, playerId) {
  const conf = npcVictoryRewards[npcId]
  if (!conf) return false
  // 发道具
  await axios.post('/item/add', {
    userId: playerId,
    itemId: conf.itemId,
    quantity: conf.quantity || 1
  })
  // 剧情对话
  if (conf.dialogs) {
    await useDialogStore().showDialogAsync(conf.dialogs)
  }
  // 系统提示
  if (conf.systemMsg) {
    await useDialogStore().showDialogAsync([
      { name: 'system', text: conf.systemMsg }
    ])
  }
  return true
}
